module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-Kh-Lc.023c8f4a.png";